import { useCallback } from 'react';

import { DialogId } from './dialogTypes';
import { useOpenDialogMutation } from './openDialog';

export function useDialog(dialogId: DialogId) {
  const [toggleDialog, { data }] = useOpenDialogMutation({
    fixedCacheKey: dialogId,
  });

  const handleOpen = useCallback(() => {
    void toggleDialog({ open: true });
  }, [toggleDialog]);

  const handleClose = useCallback(() => {
    void toggleDialog({ open: false });
  }, [toggleDialog]);

  return {
    open: !!data?.open,
    handleClose,
    handleOpen,
  };
}
